import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CotizacionGridState } from './types';
import { RootState } from 'src/app/store';

const initialState: CotizacionGridState = {
  // Data
  //data: [],
  selectedRow: null,

  // Actions
  actions: null,
};

const gridSlice = createSlice({
  name: 'cotizacionGrid',
  initialState,
  reducers: {
    setDataLoaded(state) {
      state.actions = {
        nuevo: {
          visible: true,
          disabled: false,
          tooltip: 'Agregar cotización',
        },
        copiar: {
          visible: true,
          disabled: true,
          tooltip: 'Debe seleccionar una cotización para copiarla',
        },
      };
    },
    setRowSelection(state, action: PayloadAction<any>) {
      // Data
      state.selectedRow = action.payload;

      // Actions
      state.actions = {
        nuevo: {
          visible: true,
          disabled: false,
          tooltip: 'Agregar cotización',
        },
        copiar: {
          visible: true,
          disabled: false,
          tooltip: 'Generar una copia de la cotización',
        },
      };
    },
    setUnselectedRow(state) {
      // Data
      state.selectedRow = null;

      // Actions
      state.actions = {
        nuevo: {
          visible: true,
          disabled: false,
          tooltip: 'Agregar cotización',
        },
        copiar: {
          visible: true,
          disabled: true,
          tooltip: '',
        },
      };
    },
  },
});

export const { setRowSelection, setUnselectedRow, setDataLoaded } =
  gridSlice.actions;

// Actions
export const selectNuevo = (state: RootState) =>
  state.cotizacion.grid.actions?.nuevo;
export const selectCopiar = (state: RootState) =>
  state.cotizacion.grid.actions?.copiar;

// Data
export const selectSelectedRow = (state: RootState) =>
  state.cotizacion.grid.selectedRow;

export default gridSlice.reducer;
